<template>
  <div class="re-account-dialog">
    <span class="btn-edit" @click="dialogVisible = true"></span>
    <el-dialog
      :title="$t('public50')"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="info-dialog"
    >
      <div class="dialog-form">
        <el-form
          :model="formData"
          :rules="rules"
          ref="formData"
          class="form-data"
        >
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="formData.password"
              :placeholder="$t('user6')"
              show-password
            ></el-input>
          </el-form-item>

          <el-form-item prop="rePassword">
            <el-input
              type="password"
              v-model="formData.rePassword"
              show-password
              :placeholder="$t('user112')"
            ></el-input>
          </el-form-item>

          <el-form-item prop="code" style="text-align: left">
            <el-input
             type="password"
             show-password
              v-model="formData.code"
              :placeholder="$t('user111')"
            >
            </el-input>
          </el-form-item>

          <el-form-item>
            <div
              class="btn kg-btn2"
              type="primary"
              @click="submitForm('formData')"
            >
              <I18Lang id="user84" defaultText="提交" />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import i18n from '@utils/i18n'
export default {
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('user25'))) // 请输入密码
      } else if (value.length < 8) {
        callback(new Error(i18n.t('public12'))) // 密码长度不能小于8位
      } else if (value.length > 16) {
        callback(new Error(i18n.t('public13'))) // 密码长度不能大于16位
      } else if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(value)) {
        callback(new Error(i18n.t('public14'))) // 必须同时包含数字和字母
      } else {
        if (this.formData.rePassword !== '') {
          this.$refs.formData.validateField('rePassword')
        }
        callback()
      }
    }
    const validateRePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password again'))
      } else if (value !== this.formData.password) {
        callback(new Error('The passwords entered twice do not match!'))
      } else {
        callback()
      }
    }

    return {
      dialogVisible: false,
      sendLoading: false,
      isSendCode: false,
      isSubmitLoading: false,
      email: '',
      formData: {
        rePassword: '',
        code: '',
        password: ''
      },
      rules: {
        code: [
          { required: true, message: i18n.t('user25'), trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        rePassword: [
          { required: true, validator: validateRePass, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    sendEmailCode () {
      const params = {
        email: this.userInfo.email,
        event: 'update_trade_password'
      }
      this.sendLoading = true
      this.$http
        .post(this.userInfo.verify_email ? '/api/email/send' : '/api/sms/send', params)
        .then((result) => {
          this.isSendCode = true
          this.sendLoading = false
        })
        .catch(() => {
          this.sendLoading = false
        })
    },
    submitForm (formName) {
      this.isSubmitLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit()
        } else {
          this.isSubmitLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    submit () {
      this.$http
        .post('/api/user/updateTradePassword', this.formData)
        .then((result) => {
          this.$alert(this.$t('user110'), '', {
            confirmButtonText: this.$t('my25'),
            center: true,
            dangerouslyUseHTMLString: true,
            customClass: 'success-alert',
            callback: (action) => {}
          })

          this.dialogVisible = false
        })
        .finally(() => {
          this.isSubmitLoading = false
          this.formData = {
            rePassword: '',
            code: '',
            password: ''
          }
          this.$refs.formData.resetFields()
        })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  computed: {
    ...mapState(['userInfo'])
  }
}
</script>

<style scoped lang="scss">
.re-account-dialog {
  display: inline-block;
}

.btn-edit {
  display: inline-block;
}

::v-deep .info-dialog {
  .el-dialog {
    width: 606px !important;
    min-height: 420px;
    height: 420px;
    background: url("../../../../assets/img/user/short-bg.png") no-repeat center /
      100% 100%;

    .el-dialog__header {
      .el-dialog__title {
        padding-top: 5px;
        text-align: left;
      }

      .el-dialog__headerbtn {
        margin-top: 8px;
      }
    }

    .el-input-group__append {
      background: transparent;
      border: 1px solid rgba(1, 178, 245, 0.5);
      border-left: none;

      button {
        cursor: pointer;
        color: #fff;
      }
    }

    .el-dialog__body {
      padding-bottom: 10px;
    }

    .form-item {
      margin-bottom: 35px;

      .form-item-label {
        font-size: 16px;
        font-weight: 400;
        color: #01b2f5;
        margin-bottom: 10px;
      }

      .form-item-value {
        font-size: 16px;
        font-family: Arial;
        font-weight: 400;
        color: rgb(#ffffff, 0.6);
      }
    }

    .input-tips {
      display: inline-block;
      padding: 0 10px;
      height: 19px;
      background: rgb(#000, 0.3);
      margin-top: 4px;
      border: none;
      border-radius: 0;
      font-size: 12px;
      font-family: Arial;
      font-weight: 400;
      color: #ffffff;
      line-height: 19px;
      text-align: center;
    }
  }
}
</style>
